export default {"src":"/_next/static/media/oranges.89971b5b.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};